import { jsonKeyMapping } from "../../../Config/Constants";
import { TemplateObject } from "../../../Models/TemplateObject";

type Props = {
  formElement: TemplateObject;
};

const InputHeading = ({ formElement }: Props) => {
  return (
    <>
      <div className="row">
        {" "}
        <label>{formElement[jsonKeyMapping.FORM_LABEL] || ""}</label>
        {formElement[jsonKeyMapping.FORM_SUBTEXT] && (
          <small>{formElement[jsonKeyMapping.FORM_SUBTEXT]}</small>
        )}
      </div>
    </>
  );
};

export default InputHeading;
